import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { PetitionProvider } from '../../providers/petition/petition';


@IonicPage()
@Component({
  selector: 'page-annulments',
  templateUrl: 'annulments.html',
})
export class AnnulmentsPage {

  petitions;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public petitionProvider: PetitionProvider,
  ) {
    this.petitions = petitionProvider.getAvailableAnnulments();
  }

  info(petition) {
    this.navCtrl.push('PetitionInfoPage', { mode: 'annulment', petition: petition });
  }

}



// WEBPACK FOOTER //
// ./src/pages/annulments/annulments.ts